import { httpClient } from "./httpClient";
import {
  RequestDetailsForApprovalResponse,
  RequestForAttestation,
} from "./types";

export const getRequestForAttestation = async () => {
  try {
    const { data } = await httpClient.get<{
      requests: RequestForAttestation[];
    }>(`/api/v1/request/for-attestation`);
    return data.requests;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.errorCode);
    } else {
      throw err;
    }
  }
};

export async function getRequestAccessAttestationEmail(
  encryptId: string
): Promise<RequestDetailsForApprovalResponse> {
  try {
    const { data } = await httpClient.get(
      `/api/v1/request/encryptId/${encryptId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export async function signAttestationEmail(
  headerId: number,
  accepted: boolean,
  userAttestationName: string
) {
  try {
    return httpClient.post(`/api/v1/request/${headerId}/sign-attestation`, {
      attestationName: userAttestationName,
      accepted: accepted,
    });
  } catch (error) {
    throw error;
  }
}
